var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"bg-variant":"white","text-variant":"#416e79"}},[_c('h4',{staticClass:"title"},[_c('router-link',{attrs:{"to":{name: 'postAnswer', params: { imgID: _vm.question['.key'] }}}},[_vm._v(_vm._s(_vm.question.question))])],1),_vm._v(" "),_c('h6',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.categoryKey[_vm.question.category]))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67a71874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = 416X
// module chunks = 1